import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import makeDataProps from 'lib/makeDataProps';
import './blocky-date-picker.scss';

export default class BlockyDatePicker extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.any,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    inputRef: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    required: PropTypes.bool,
    value: PropTypes.string
  };

  static defaultProps = {
    className: '',
    onChange: () => {},
    onFocus: () => {},
    inputRef: () => {}
  };

  render() {
    const dataProps = makeDataProps(this.props);

    const label = this.props.label ? (
      <div className='blocky-date-picker__label'>
        <label htmlFor={this.props.name}>{this.props.label}</label>
      </div>
    ) : null;

    const inputClass = classnames('blocky-date-picker__input', {
      'blocky-date-picker__input--error': this.props.error
    });

    const errorContainer = this.props.errorMessage ? (
      <div className='a-form-input__error'>{this.props.errorMessage}</div>
    ) : null;

    const wrapperClassnames = classnames('blocky-date-picker', this.props.className, {
      'blocky-date-picker--required': this.props.required
    });

    return (
      <div className={wrapperClassnames}>
        {label}
        <input
          className={inputClass}
          disabled={this.props.disabled}
          id={this.props.name}
          name={this.props.name}
          type='date'
          onBlur={this.props.onBlur}
          placeholder='YYYY/MM/DD' // Fallback placeholder
          onChange={this.props.onChange}
          onFocus={this.props.onFocus}
          ref={(node) => {
            this.inputNode = node;
            this.props.inputRef(node);
          }}
          defaultValue={this.props.defaultValue}
          value={this.props.value}
          {...dataProps}
        />
        {errorContainer}
      </div>
    );
  }
}
